import React from "react";
import styled from 'styled-components';
import PropTypes from 'prop-types';

var DragIcon = function DragIcon(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    className: className,
    viewBox: "0 0 10 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 14.9917C4 16.0911 3.1 16.9907 2 16.9907C0.9 16.9907 0 16.0911 0 14.9917C0 13.8922 0.9 12.9926 2 12.9926C3.1 12.9926 4 13.8922 4 14.9917ZM2 6.99531C0.9 6.99531 0 7.8949 0 8.99439C0 10.0939 0.9 10.9935 2 10.9935C3.1 10.9935 4 10.0939 4 8.99439C4 7.8949 3.1 6.99531 2 6.99531ZM2 0.998047C0.9 0.998047 0 1.89764 0 2.99713C0 4.09663 0.9 4.99622 2 4.99622C3.1 4.99622 4 4.09663 4 2.99713C4 1.89764 3.1 0.998047 2 0.998047ZM8 4.99622C9.1 4.99622 10 4.09663 10 2.99713C10 1.89764 9.1 0.998047 8 0.998047C6.9 0.998047 6 1.89764 6 2.99713C6 4.09663 6.9 4.99622 8 4.99622ZM8 6.99531C6.9 6.99531 6 7.8949 6 8.99439C6 10.0939 6.9 10.9935 8 10.9935C9.1 10.9935 10 10.0939 10 8.99439C10 7.8949 9.1 6.99531 8 6.99531ZM8 12.9926C6.9 12.9926 6 13.8922 6 14.9917C6 16.0911 6.9 16.9907 8 16.9907C9.1 16.9907 10 16.0911 10 14.9917C10 13.8922 9.1 12.9926 8 12.9926Z",
    fill: "white"
  }));
};

DragIcon.propTypes = {
  className: PropTypes.string
};
var DragIconStyled = styled(DragIcon).withConfig({
  displayName: "icon-drag__DragIconStyled",
  componentId: "sc-xkfyxo-0"
})(["width:20px;height:20px;"]);
export default DragIconStyled;